<template>
  <div class="list-group">
    <div class="list-group-item">
      <h1>{{ $t("nav.dashboard") | title }}</h1>
      <div class="list-group">
        <div class="list-group-item">
          <div class="row">
            <div class="col">
              {{ $t("message.sent") | capitalize }}/{{
                $t("message.received") | capitalize
              }}
            </div>
            <div class="col">
              {{ $t("message.picked") | capitalize }}/{{
                $t("message.requested") | capitalize
              }}
            </div>
            <div class="col">
              {{ $t("message.sent_expired") | capitalize }}/{{
                $t("message.received_expired") | capitalize
              }}
            </div>
          </div>
        </div>
        <div class="list-group-item" v-if="userProfile.details">
          <div class="row">
            <div class="col">
              {{ userProfile.details.sent }}/{{
                userProfile.details.received_confirmed
              }}
            </div>
            <div class="col">
              {{ userProfile.details.picked }}/{{
                userProfile.details.requested
              }}
            </div>
            <div class="col">
              {{ userProfile.details.sent_expired }}/{{
                userProfile.details.received_expired
              }}
            </div>
          </div>
        </div>
        <div class="list-group-item" v-if="canRequest">
          <button
            @click="getAddress"
            :disabled="request_loading"
            class="btn btn-success btn-block"
          >
            {{ $t("dashboard.request_available") }}
          </button>
        </div>
        <div class="list-group-item" v-else>
          {{ $t("dashboard.request_unavailable") }}
        </div>
        <div class="list-group-item" v-if="canReceive">
          {{ $t("dashboard.eligible") }}
        </div>
        <div class="list-group-item" v-else>
          {{ $t("dashboard.not-eligible") }}
        </div>
      </div>
    </div>
    <div class="list-group-item">
      <!-- sent cards -->
      <div class="list-group">
        <h3>{{ $t("cards.sending") | title }}</h3>
        <div
          class="list-group-item"
          v-for="(card, index) in sentCards"
          :key="index"
        >
          <div class="row">
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("cards.status") | capitalize }}
              </div>
              {{ $t("cards.stage_" + card.stage) | capitalize }}
            </div>
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("cards.code") | capitalize }}
              </div>
              {{ card.code }}
            </div>
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("message.sent") | capitalize }}
              </div>
              <i18ndate :date="card.sent" />
            </div>
            <div class="col">
              <button
                class="btn btn-success"
                type="button"
                :disabled="address.loading"
                @click="loadAddress(card, 'modal-' + index)"
              >
                {{ $t("dashboard.show_address") | title }}
              </button>
              &nbsp;
              <button
                v-if="!!card.sent == false"
                class="btn btn-secondary"
                type="button"
                v-b-modal="'sent-' + index"
              >
                {{ $t("message.mark_sent") | title }}
              </button>
              <!-- TODO: Address modal-->
              <b-modal
                :id="'modal-' + index"
                :title="$t('address.address', ['']) | capitalize"
              >
                <b-container fluid v-if="!address.loading">
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.address", [1]) | title }}:
                    </div>
                    <div class="col">{{ address.address_1 }}</div>
                  </div>
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.address", [2]) | title }}:
                    </div>
                    <div class="col">{{ address.address_2 }}</div>
                  </div>
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.city") | title }}:
                    </div>
                    <div class="col">{{ address.city }}</div>
                  </div>
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.state") | title }}:
                    </div>
                    <div class="col">{{ address.state }}</div>
                  </div>
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.country") | title }}:
                    </div>
                    <div class="col">{{ address.country }}</div>
                  </div>
                  <div class="row">
                    <div class="col font-weight-bold">
                      {{ $t("address.postal_code") | title }}:
                    </div>
                    <div class="col">{{ address.zip }}</div>
                  </div>
                </b-container>
                <template v-slot:modal-footer>
                  <div class="w-100">
                    <span class="font-weight-bold float-left">
                      {{ $t("cards.card_code") | title }}:
                      <h3>{{ address.card_code }}</h3>
                    </span>
                    <b-button
                      variant="primary"
                      size="sm"
                      class="float-right"
                      @click="$bvModal.hide('modal-' + index)"
                    >
                      {{ $t("message.ok") }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
              <!-- end address modal-->
              <!-- TODO: sent modal-->
              <b-modal
                :id="'sent-' + index"
                :title="$t('message.mark_sent') | title"
              >
                <b-container fluid>
                  <input class="form-control" type="date" v-model="sentDate" />
                </b-container>
                <template v-slot:modal-footer>
                  <div class="w-100">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="float-right"
                      @click="saveSent('sent-' + index, card.id)"
                    >
                      {{ $t("message.ok") }}
                    </b-button>
                  </div>
                </template>
              </b-modal>
              <!-- end sent modal-->
            </div>
          </div>
        </div>
        <div class="list-group-item" v-if="sentCards.length == 0">
          {{ $t("cards.no-sending") | capitalize }}
        </div>
      </div>
    </div>
    <div class="list-group-item">
      <!-- cards receiving -->
      <div class="list-group">
        <h3>{{ $t("cards.receiving") | title }}</h3>
        <div
          class="list-group-item"
          v-for="(card, index) in recCards"
          :key="index"
        >
          <div class="row">
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("cards.status") | capitalize }}
              </div>
              {{ $t("cards.stage_" + card.stage) | capitalize }}
            </div>
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("message.requested") | capitalize }}
              </div>
              <i18ndate :date="card.requested" />
            </div>
            <div class="col">
              <div class="font-weight-bold">
                {{ $t("message.sent") | capitalize }}
              </div>
              <i18ndate :date="card.sent" />
            </div>
            <div class="col">
              <button
                v-if="!!card.received == false"
                class="btn btn-secondary"
                type="button"
                v-b-modal="'rec-' + index"
              >
                {{ $t("message.mark_received") | title }}
              </button>
            </div>
          </div>
          <!-- TODO: rec modal-->
          <b-modal
            :id="'rec-' + index"
            :title="$t('message.mark_received') | title"
          >
            <b-container fluid>
              <div class="form-group">
                <input class="form-control" type="date" v-model="recDate" />
              </div>
              <div class="form-group">
                <label for="rd">{{ $t("cards.code") }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="code"
                  id="rd"
                />
              </div>
            </b-container>
            <template v-slot:modal-footer>
              <div class="w-100">
                <b-button
                  variant="primary"
                  size="sm"
                  class="float-right"
                  @click="saveRec('rec-' + index, card)"
                >
                  {{ $t("message.ok") }}
                </b-button>
              </div>
            </template>
          </b-modal>
          <!-- end rec modal-->
        </div>
        <div class="list-group-item" v-if="recCards.length == 0">
          {{ $t("cards.no-receiving") | capitalize }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { functions, cardDestCollection } from "@/firebase";
import i18ndate from "@/components/I18nDate";
//import $ from "jquery";
export default {
  components: {
    i18ndate
  },
  computed: {
    ...mapState(["userProfile"]),
    ...mapGetters(["sentCards", "recCards"]),
    canRequest() {
      if (this.userProfile && this.userProfile.details) {
        return this.userProfile.details.can_send > 0;
        /* Old method, keeping just in case
        const sent = this.userProfile.details.sent;
        //const received = this.userProfile.details.received;
        //const picked = this.userProfile.details.picked;
        const requested = this.userProfile.details.requested;

        const r = requested <= sent;
        const s =
          this.userProfile.details.sent_confirmed +
          this.userProfile.details.sent_expired;
        const r2 = requested < s;
        //const r2 = requested <= received
        return r && r2;*/
      }
      return false;
    },
    canReceive() {
      if (this.userProfile && this.userProfile.details) {
        return this.userProfile.details.can_receive;
        /*const received = this.userProfile.details.received;
        const sent = this.userProfile.details.sent;
        return received <= sent;*/
      }
      return false;
    }
  },
  data() {
    return {
      sentDate: new Date().toISOString().substr(0, 10),
      recDate: new Date().toISOString().substr(0, 10),
      code: "",
      cardId: "",
      request_loading: false,
      address: {
        loading: false,
        id: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        card_code: ""
      }
    };
  },
  methods: {
    async saveRec(modalId, card) {
      const self = this;
      if (this.code != card.code) {
        self.flashMessage.show({
          status: "error",
          message: self.$t("cards.invalid_code") //self.$options.filters.capitalize(self.$t("gra.success"))
        });
      } else {
        this.$bvModal.hide(modalId);
        const d = this.recDate;
        this.$store
          .dispatch("saveRec", { id: card.id, date: d })
          .then(() => {
            self.recDate = new Date().toISOString().substr(0, 10);
            self.code = "";
            self.flashMessage.show({
              status: "success",
              message: self.$t("message.updated_rec_date") //self.$options.filters.capitalize(self.$t("gra.success"))
            });
          })
          .catch(err => {
            console.log("update sent date error", err);
            self.flashMessage.show({
              status: "error",
              message: self.$t("message.error_update_rec_date") //self.$options.filters.capitalize(self.$t("gra.success"))
            });
          });
      }
    },
    saveSent(modalId, cardId) {
      const self = this;
      this.$bvModal.hide(modalId);
      console.log("cardID", cardId, this.sentDate);
      const d = this.sentDate;
      this.$store
        .dispatch("saveSent", { id: cardId, date: d })
        .then(() => {
          self.flashMessage.show({
            status: "success",
            message: self.$t("message.updated_sent_date") //self.$options.filters.capitalize(self.$t("gra.success"))
          });
          self.sentDate = new Date().toISOString().substr(0, 10);
        })
        .catch(err => {
          console.log("update sent date error", err);
          self.flashMessage.show({
            status: "error",
            message: self.$t("message.error_update_sent_date") //self.$options.filters.capitalize(self.$t("gra.success"))
          });
        });
    },
    async loadAddress(card, modalId) {
      const self = this;
      this.address.loading = true;
      if (card.id && card.id != this.address.id) {
        await cardDestCollection
          .where("user_id", "==", self.userProfile.uid)
          .limit(1)
          .get()
          .then(snap => {
            if (!snap.empty) {
              snap.forEach(ad => {
                const d = ad.data();
                console.log(d);
                self.address.id = card.id;
                self.address.address_1 = d.address.address_1;
                self.address.address_2 = d.address.address_2;
                self.address.city = d.address.city;
                self.address.state = d.address.state;
                self.address.country = d.address.country;
                self.address.zip = d.address.zip;
                self.address.card_code = card.code;
                console.log("card code", card.code);
                self.address.loading = false;
                self.$bvModal.show(modalId);
              });
            } else {
              self.flashMessage.show({
                status: "error",
                message: "address not found" //self.$options.filters.capitalize(self.$t("gra.success"))
              });
            }
          })
          .catch(err => {
            console.log("address fetch error", err);
            self.flashMessage.show({
              status: "error",
              message: err.message //self.$options.filters.capitalize(self.$t("gra.success"))
            });
          });
      }
    },
    async getAddress() {
      const self = this;
      let gra = functions.httpsCallable("getRandomAddress");
      this.request_loading = true;
      await gra({ uid: this.userProfile.uid })
        .then(function(r) {
          console.log("Random result", r);
          self.flashMessage.show({
            status: "success",
            message: self.$options.filters.capitalize(self.$t("gra.success"))
          });
          self.$store.dispatch("checkListener");
        })
        .catch(function(err) {
          console.log("random error", err.message);
          let message = "";
          if (self.$te(err.message)) {
            message = self.$t(err.message);
          } else {
            message = self.$t("gra.generic_error");
          }
          self.flashMessage.show({
            status: "error",
            message: self.$options.filters.capitalize(message)
          });
        });
      this.request_loading = false;
    }
  }
};
</script>
